import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    BuildingView,
    OpportunityBuildingClient,
    OpportunityBuildingView,
    OpportunityBuildingViewPaginatedResultDto,
    OpportunityClient,
    SearchAvailableOpportunityBuildingsParameters,
    SearchBuildingsForOpportunityParameters
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class OpportunityBuildingService {
    constructor(
        private readonly opportunityBuildingClient: OpportunityBuildingClient,
        private readonly opportunityClient: OpportunityClient
    ) {}

    async save(body: OpportunityBuildingView): Promise<OpportunityBuildingView> {
        return await lastValueFrom(this.opportunityClient.opportunitySaveBuilding(body));
    }

    async remove(id: number): Promise<void> {
        return await lastValueFrom(this.opportunityBuildingClient.opportunityBuildingDelete(id));
    }

    async setAsMain(body: OpportunityBuildingView): Promise<void> {
        return await lastValueFrom(this.opportunityBuildingClient.opportunityBuildingSetBuildingAsMain(body));
    }

    async unsetAsMain(body: OpportunityBuildingView): Promise<void> {
        return await lastValueFrom(this.opportunityBuildingClient.opportunityBuildingUnsetAsMain(body));
    }

    async searchForOpportunity(
        body: SearchBuildingsForOpportunityParameters
    ): Promise<OpportunityBuildingViewPaginatedResultDto> {
        return await lastValueFrom(this.opportunityBuildingClient.opportunityBuildingSearchForOpportunity(body));
    }

    async searchAvailable(body: SearchAvailableOpportunityBuildingsParameters): Promise<BuildingView[]> {
        return await lastValueFrom(this.opportunityBuildingClient.opportunityBuildingSearchAvailable(body));
    }
}
